import React from "react";

const VerifiedBadge = ({ user }) => {
  const badgeActive = Boolean(user?.channelIsBadgeActive ?? user?.isBadgeActive ?? user?.channelIsVerified ?? user?.isVerified ?? user?.verification?.isVerifiedUser);
  const phoneVerified = Boolean(user?.channelIsPhoneVerified ?? (user?.isPhoneVerified && (user?.mobileNumber || user?.phoneNumber)));

  if (!badgeActive) return <span>Not verified</span>;
  if (!phoneVerified) {
    return (
      <span title="Badge entitlement is active; phone verification is pending">
        <span className="d-block" style={{ color: "#805900" }}>Verify phone number</span>
        <small className="text-muted">Badge active</small>
      </span>
    );
  }

  return (
    <span title="Verified user" aria-label="Verified user" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "28px", height: "34px" }}>
      <img src="/verified_icon.png" alt="Verified" width="28" height="34" style={{ display: "block", width: "28px", height: "34px", objectFit: "contain" }} />
    </span>
  );
};

export default VerifiedBadge;

export const PhoneStatus = ({ user }) => {
  const verified = Boolean(user?.isPhoneVerified && user?.mobileNumber);
  const date = user?.phoneVerifiedAt ? new Date(user.phoneVerifiedAt) : null;
  const validDate = date && Number.isFinite(date.getTime());
  return (
    <span>
      <span className="d-block">{user?.mobileNumber || "Not provided"}</span>
      <small className="text-muted">{verified ? "Phone verified" : "Phone not verified"}</small>
      {verified && validDate && <small className="d-block text-muted" title={date.toISOString()}>{date.toLocaleDateString()}</small>}
    </span>
  );
};